import { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useUIStore } from '../../stores/uiStore';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
}

/**
 * Main layout wrapper component.
 * Provides the overall structure with sidebar, header, and main content area.
 * Handles responsive behavior for mobile screens.
 * 
 * Requirements: 10.1, 10.2
 */
export function Layout({ children }: LayoutProps) {
  const { sidebarOpen, sidebarCollapsed } = useUIStore();

  return (
    <div className="layout">
      <Sidebar />
      <div
        className={`layout-main ${sidebarCollapsed ? 'sidebar-collapsed' : ''} ${
          !sidebarOpen ? 'sidebar-hidden' : ''
        }`}
      >
        <Header />
        <main className="layout-content">{children}</main>
      </div>
      {/* Mobile overlay when sidebar is open */}
      {sidebarOpen && (
        <div
          className="layout-overlay"
          onClick={() => useUIStore.getState().setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}
    </div>
  );
}
